// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from 'constants/ActionTypes';
import * as Actions from "actions";

function* adminGetInstagramMedia(action: Object) {
  try {
    const { shopId, page, limit, filterType, sortOrder, mediaTypeFilter } = action;
    
    const response = yield API.post(`/admin/instagram/shop-media`, {
      shop_id: shopId,
    }, {
      params: {
        page: page || 1,
        limit: limit || 50,
        filter: filterType || 'all',
        sort: sortOrder || 'newest',
        media_type: mediaTypeFilter || 'both'
      }
    });
    
    yield put(Actions.adminGetInstagramMediaSuccess(response));
  } catch (error) {
    yield put(Actions.adminGetInstagramMediaFailure(error));
  }
}

function* adminGetInstagramMediaStats(action: Object) {
  try {
    const { shopId } = action;
    
    const response = yield API.get(`/admin/instagram/media/${shopId}/stats`);
    
    yield put(Actions.adminGetInstagramMediaStatsSuccess(response));
  } catch (error) {
    yield put(Actions.adminGetInstagramMediaStatsFailure(error));
  }
}

function* adminSyncInstagramMedia(action: Object) {
  try {
    const { shopId, accessToken, systemAccountId, mediaLimit } = action;
    
    const response = yield API.post(`/admin/instagram/sync-media`, {
      shop_id: shopId,
      access_token: accessToken,
      system_instagram_account_id: systemAccountId,
      media_limit: mediaLimit || 50
    });
    
    yield put(Actions.adminSyncInstagramMediaSuccess(response));
  } catch (error) {
    yield put(Actions.adminSyncInstagramMediaFailure(error));
  }
}

function* adminCreateProductsFromInstagram(action: Object) {
  try {
    const { shopId, selectedMedia } = action;
    
    if (!selectedMedia || selectedMedia.length === 0) {
      throw new Error('No media selected');
    }

    const results = [];
    const errors = [];

    // Process each media item sequentially
    for (const media of selectedMedia) {
      try {
        // Single API call: Download, upload to Cloudinary, create product, and link
        const response = yield API.post(`/admin/instagram/upload-media`, {
          media_url: media.media_url,
          media_type: media.media_type,
          shop_id: shopId,
          instagram_media_id: media.instagram_media_id
        });

        if (!response.response || !response.response.product_id) {
          throw new Error('Failed to create product');
        }

        console.log(`✓ Created product ${response.response.product_id} from ${media.media_type}`);

        results.push({
          instagram_media_id: media.instagram_media_id,
          success: true,
          product_id: response.response.product_id,
          job_id: response.response.job_id,
          cloudinary_url: response.response.cloudinary_url
        });
      } catch (error) {
        console.error(`Failed to create product from media ${media.media_id}:`, error);
        errors.push({
          media_id: media.media_id,
          error: error.message || 'Failed to create product'
        });
      }
    }

    yield put(Actions.adminCreateProductsFromInstagramSuccess({
      total: selectedMedia.length,
      successful: results.length,
      failed: errors.length,
      results: results,
      errors: errors
    }));
  } catch (error) {
    yield put(Actions.adminCreateProductsFromInstagramFailure(error));
  }
}

function* adminAddVideoToProduct(action: Object) {
  try {
    const { mediaUrl, productId, instagramMediaId } = action;
    
    const response = yield API.post(`/admin/instagram/add-video-to-product`, {
      media_url: mediaUrl,
      product_id: productId,
      instagram_media_id: instagramMediaId
    });
    
    yield put(Actions.adminAddVideoToProductSuccess(response));
  } catch (error) {
    yield put(Actions.adminAddVideoToProductFailure(error));
  }
}

function* adminUpdateShopFollowers(action: Object) {
  try {
    const { shopId, accessToken, systemAccountId } = action;
    
    const response = yield API.post(`/admin/instagram/update-shop`, {
      shop_id: shopId,
      access_token: accessToken,
      system_instagram_account_id: systemAccountId
    });
    
    yield put(Actions.adminUpdateShopFollowersSuccess(response));
  } catch (error) {
    yield put(Actions.adminUpdateShopFollowersFailure(error));
  }
}

export default function* adminInstagramSaga() {
  yield takeLatest(ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_START, adminGetInstagramMedia);
  yield takeLatest(ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_START, adminGetInstagramMediaStats);
  yield takeLatest(ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_START, adminSyncInstagramMedia);
  yield takeLatest(ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_START, adminCreateProductsFromInstagram);
  yield takeLatest(ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_START, adminAddVideoToProduct);
  yield takeLatest(ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_START, adminUpdateShopFollowers);
}

